import {createContext, ReactNode, useContext, useState} from "react";
import {useServerId} from "../../client/useServerId";
import {useData} from "../../../hooks/useData";
import {GetAuthResponse} from "../../client/interfaces";
import {useWatcher} from "../../../hooks/useWatcher";

const Context = createContext<AuthContextData>(null!)

export default function AuthContext(props: { children: ReactNode }) {
    const serverId = useServerId()
    const authResult = useData<GetAuthResponse>(`/api/client/auth?serverId=${serverId}`)

    const [info, setInfo] = useState<AuthContextData>({
        loaded: false,
    })

    useWatcher(authResult.data, result => {
        if (result){
            console.warn("update auth info")
            setInfo({
                loaded: true,
                isLoggedIn: result.isLoggedIn,
                userName: result.userName,
                avatarUrl: result.avatarUrl,
                email: result.email,
                isValidServerId: result.isValidServerId
            })
        }
    })

    return <Context.Provider value={info}>
        {props.children}
    </Context.Provider>
}

export const useAuth = () => useContext(Context)

interface AuthContextData{
    loaded: boolean
    isLoggedIn?: boolean
    // When logged in:
    userName?: string
    avatarUrl?: string
    email?: string
    isValidServerId?: boolean
}